<div #timeline class="timeline-wrapper">
    <ng-content></ng-content>
</div>
  